import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function AddExistingPropertyIcon({
  className,
  fill,
  height,
  stroke = IconColors.DarkGrey,
  width,
}: SimpleIconInterface) {
  return (
    <SimpleIcon
      className={className}
      fill={fill ?? 'none'}
      height={height ?? '18'}
      viewBoxDimensions="0 0 18 18"
      width={width ?? '18'}
    >
      <path
        d="M11.25 15.75C10.8375 15.75 10.4844 15.6031 10.1906 15.3094C9.89688 15.0156 9.75 14.6625 9.75 14.25V3.75C9.75 3.3375 9.89688 2.98438 10.1906 2.69063C10.4844 2.39688 10.8375 2.25 11.25 2.25H14.25C14.6625 2.25 15.0156 2.39688 15.3094 2.69063C15.6031 2.98438 15.75 3.3375 15.75 3.75V14.25C15.75 14.6625 15.6031 15.0156 15.3094 15.3094C15.0156 15.6031 14.6625 15.75 14.25 15.75H11.25ZM11.25 3.75V14.25H14.25V3.75H11.25ZM3.75 15.75C3.3375 15.75 2.98438 15.6031 2.69063 15.3094C2.39688 15.0156 2.25 14.6625 2.25 14.25V3.75C2.25 3.3375 2.39688 2.98438 2.69063 2.69063C2.98438 2.39688 3.3375 2.25 3.75 2.25H6.75C7.1625 2.25 7.51562 2.39688 7.80937 2.69063C8.10313 2.98438 8.25 3.3375 8.25 3.75V14.25C8.25 14.6625 8.10313 15.0156 7.80937 15.3094C7.51562 15.6031 7.1625 15.75 6.75 15.75H3.75ZM3.75 3.75V14.25H6.75V3.75H3.75Z"
        fill={stroke}
      />
    </SimpleIcon>
  );
}
